// @flow
import React, { useEffect, useState, useCallback } from "react";
import { withRouter, Prompt } from "react-router";

type Props = { isDirty: boolean, message: ?string | ?boolean };

const NavigationBlock = ({ isDirty, message, history }: Props) => {
    const [shouldDisplayPrompt, setShouldDisplayPrompt] = useState(true);
    const [keepDirty, setKeepDirty] = useState(false);

    const handleNavigation = useCallback(() => {
        if (isDirty) {
            // if the user wants to stay on the page, keep the prompt
            if (keepDirty) {
                setKeepDirty(false);
                return;
            }
            // don't show the prompt more than one times
            setShouldDisplayPrompt(false);
        }
    }, [isDirty, setShouldDisplayPrompt, keepDirty, setKeepDirty]);

    useEffect(() => {
        const unlisten = history.listen(() => {
            handleNavigation();
        });

        return () => {
            unlisten();
        };
    }, [handleNavigation, history]);

    useEffect(() => {
        if (isDirty === true) {
            window.onbeforeunload = /* istanbul ignore next */ () => message;
        } else {
            window.onbeforeunload = undefined;
        }

        return () => {
            window.onbeforeunload = undefined;
        };
    }, [isDirty, message]);

    if (message == null) return null;
    return (
        <Prompt
            when={isDirty && shouldDisplayPrompt}
            message={(_, navAction) => {
                /* istanbul ignore else */
                if (navAction === "POP") {
                    setKeepDirty(true);
                }
                return message;
            }}
        />
    );
};

export default withRouter(NavigationBlock);
